import { Vector3 } from "three/webgpu";
import { decomposeWorldPositionToCartography } from "../config/worldFrame";
import type { RaymarchFieldPoint, SemanticWorldPosition } from "./SpatialProjectionPipeline";

export class RaymarchFieldProjector {
  private readonly components = new Vector3();

  fromSemantic(position: SemanticWorldPosition): RaymarchFieldPoint {
    decomposeWorldPositionToCartography(position, this.components);
    return [this.components.x, this.components.y];
  }
}
